import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../AuthContext";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faAngleDown,
  faBookmark,
  faClose,
  faHeart,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import ImageComponent from "../pages/articales/ImageComponent";
import DeletePopupuo from "./DeletePopupuo";

const CACHE_KEY_ARTICLE_CAT = "articleCategories";
const CACHE_KEY_ALL_ARTICLES = "allArticles";
const CACHE_EXPIRY_MS = 0;

const getCachedData = (key) => {
  const cached = localStorage.getItem(key);
  if (!cached) return null;

  const { data, timestamp } = JSON.parse(cached);
  if (Date.now() - timestamp > CACHE_EXPIRY_MS) {
    localStorage.removeItem(key);
    return null;
  }

  return data;
};

const setCachedData = (key, data) => {
  const cacheData = {
    data,
    timestamp: Date.now(),
  };
  localStorage.setItem(key, JSON.stringify(cacheData));
};

const ArticlesDashboard = () => {
  const [articlesCategory, setArticlesCategory] = useState([]);
  const [name, setName] = useState("");
  const [allArticles, setAllArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  const [categoryArticles, setCategoryArticles] = useState([]);
  const [posted, setPosted] = useState(null);
  const [shownn, setShownn] = useState(false);
  const { setArticleDet, favoriteItem, articleSaving, auth } =
    useContext(AuthContext);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const articlesPerPage = 4;
  const [formData, setFormData] = useState({
    CategoryName: "",
    Description: "",
    CategoriesArticleId: 0,
    Treatment: "",
    Symptoms: "",
    Image: null,
  });

  const handleDeleteClick = (feedId) => {
    setItemToDelete(feedId);
    setShowDeletePopup(true);
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const paginate = (items, currentPage, itemsPerPage) => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return items.slice(indexOfFirstItem, indexOfLastItem);
  };

  const handleDropdownnn = () => {
    setShownn(!shownn);
  };

  // feachcategries

  useEffect(() => {
    const fetchAllArticles = async () => {
      console.log("Fetching all articles...");
      const cachedData = getCachedData(CACHE_KEY_ALL_ARTICLES);
      if (cachedData) {
        console.log("Using cached all articles");
        setAllArticles(cachedData);
        return;
      }
      setLoading(true);
      try {
        const response = await axios.get(
          "https://sychoclinicapi.runasp.net/api/Categories"
        );
        console.log("Fetched all articles: ", response.data);
        setAllArticles(response.data);
        setCachedData(CACHE_KEY_ALL_ARTICLES, response.data);
      } catch (error) {
        console.error("Failed to fetch all articles", error);
      }
    };

    fetchAllArticles();
  }, [itemToDelete, posted]);

  // feachcategries

  useEffect(() => {
    const fetchArticleCat = async () => {
      console.log("Fetching article categories...");
      const cachedData = getCachedData(CACHE_KEY_ARTICLE_CAT);
      if (cachedData) {
        console.log("Using cached article categories");
        setArticlesCategory(cachedData);
        return;
      }
      
      try {
        const response = await axios.get(
          "https://sychoclinicapi.runasp.net/api/categories/details"
        );
        console.log("Fetched article categories: ", response.data);
        setArticlesCategory(response.data);
        setCachedData(CACHE_KEY_ARTICLE_CAT, response.data);
      } catch (error) {
        console.error("Failed to fetch article categories", error);
      }
    };

    fetchArticleCat();
  }, [itemToDelete, posted]);

  useEffect(() => {
    if (articlesCategory.length > 0 && allArticles.length > 0) {
      console.log("Organizing articles...");
      console.log("Articles Category: ", articlesCategory);
      console.log("All Articles: ", allArticles);

      const organizedArray = articlesCategory.map((item) => {
        if (!item.categoriesArticleId) {
          console.warn(
            `categoriesArticleId is undefined for article id: ${item.id}`
          );
          return item;
        }

        const correspondingItem = allArticles.find(
          (obj) => obj.id === item.categoriesArticleId
        );

        if (!correspondingItem) {
          console.warn(
            `No corresponding item found for article id: ${item.categoriesArticleId}`
          );
          return item;
        }
        
        return {
          ...item,
          correspondingItem: {
            description: correspondingItem.description,
            categoryName: correspondingItem.typeName,
            image: correspondingItem.image,
            },
            };
            }
            );
          setLoading(false)
    console.log("Organized array: ", organizedArray);
    const categories = allArticles.reduce((uniqueCategories, item) => {
      if (item.typeName && !uniqueCategories.includes(item.typeName)) {
        uniqueCategories.push(item.typeName);
        }
        return uniqueCategories;
        }, []);
        
        console.log("Categories: ", categories);
        
        const categoryArticlesData = categories.map((category) => {
          const articles = organizedArray.filter(
            (item) =>
              item.correspondingItem &&
            item.correspondingItem.categoryName === category
            );
            return { category, articles };
            });
            console.log("Category articles data: ", categoryArticlesData);
            
            setCategoryArticles(categoryArticlesData);
            setArticleDet(categoryArticlesData);
            }
  }, [articlesCategory, allArticles, setArticleDet,]);

  const handleDeleteConfirm = async () => {
    if (!itemToDelete) return;
    const token = auth.token;
    setLoading(true);
    try {
      await axios.delete(
        `https://sychoclinicapi.runasp.net/api/Categories/Detials/${itemToDelete}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSelectedCategory(
        selectedCategory.articles.filter(
          (article) => article.id !== itemToDelete
        )
        );
        
        
        setSelectedCategory(null)
      setShowDeletePopup(false);
      setItemToDelete(null);

      // Refetch articles after adding a new one
      const fetchUpdatedArticles = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            "https://sychoclinicapi.runasp.net/api/Categories"
          );
          console.log("Fetched all articles: ", response.data);
          setAllArticles(response.data);
          setName('All Articles')
          setCachedData(CACHE_KEY_ALL_ARTICLES, response.data);
        } catch (error) {
          console.error("Failed to fetch all articles", error);
        }
      };

      fetchUpdatedArticles();
    } catch (error) {
      console.error("Error deleting the feedback:", error);
      setShowDeletePopup(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeletePopup(false);
    setItemToDelete(null);
  };

  const handleImageChange = (e) => {
    const imageFile = e.target.files[0];
    setFormData((prevFormData) => ({ ...prevFormData, Image: imageFile }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: name === "CategoriesArticleId" ? parseInt(value, 10) || 0 : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = auth.token;

    const formDataToSend = new FormData();
    formDataToSend.append("CategoryName", formData.CategoryName);
    formDataToSend.append("Description", formData.Description);
    formDataToSend.append("CategoriesArticleId", formData.CategoriesArticleId);
    formDataToSend.append("Treatment", formData.Treatment);
    formDataToSend.append("Symptoms", formData.Symptoms);
    if (formData.Image) {
      formDataToSend.append("Image", formData.Image);
    }
    setLoading(true);
    try {
      const response = await axios.post(
        "https://sychoclinicapi.runasp.net/api/Categories/details",
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Form Data Submitted:", formData);
      setPosted(response.data);
      console.log("Response:", response.data);
      setFormData({
        CategoryName: "",
        Description: "",
        Image: null,
        CategoriesArticleId: 0,
        Treatment: "",
        Symptoms: "",
      });

      // Refetch articles after adding a new one
      const fetchUpdatedArticles = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            "https://sychoclinicapi.runasp.net/api/Categories"
          
          );
          console.log("Fetched all articles: ", response.data);
          setAllArticles(response.data);
          setName('All Articles')
          setCachedData(CACHE_KEY_ALL_ARTICLES, response.data);
        } catch (error) {
          console.error("Failed to fetch all articles", error);
        }
      };

      fetchUpdatedArticles();
    } catch (error) {
      console.error("Error submitting the form:", error);
    }
  };

  const displayedArticles =
    selectedCategory &&
    selectedCategory.articles &&
    paginate(selectedCategory.articles, currentPage, articlesPerPage);

  return (
    <div id="articleDashboard">
      {loading && (
        <div
          style={{
            backgroundColor: "#EEE",
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            zIndex: "1000",
            opacity: ".6",
          }}
        >
          <span className="spinner-border text-dark" role="status"></span>
        </div>
      )}
      {showDeletePopup && (
        <DeletePopupuo
          handleDeleteConfirm={handleDeleteConfirm}
          handleDeleteCancel={handleDeleteCancel}
        />
      )}
      <section className=" vh-100 w-100  d-flex justify-content-center align-items-center flex-column ">
        <h4
          className="mt-0 ms-0 pb-1"
          style={{ textDecoration: "underline blue" }}
        >
          Articles
        </h4>

        <div className=" col-lg-8 col-md-10 col-sm-12 h-75 w-sm-100 w-md-50 w-lg-50 ">
          <div className="d-flex align-items-center justify-content-center flex-wrap py-2 px-2 gap-2 mb-5 ">
            <div className="border border-secondary bg-primary text-white shadow rounded-3 px-5 py-2">
              <div className="">
                <FontAwesomeIcon
                  className="text-white bg-white rounded-circle"
                  icon={faCircle}
                />
                All Articles
              </div>
              <span className="fw-bold  ps-3 ">{articlesCategory.length}</span>
            </div>
            <div className="border  border-primary shadow  rounded-3 px-5 py-2">
              <div className="">
                <FontAwesomeIcon icon={faHeart} /> Favorites
              </div>
              <span className="fw-bold  ps-3 ">{favoriteItem.length}</span>
            </div>
            <div className="border border-primary  shadow rounded-3 px-5 py-2">
              <div className="">
                <FontAwesomeIcon icon={faBookmark} /> Saveed
              </div>
              <span className="fw-bold  ps-3 ">{articleSaving.length}</span>
            </div>
          </div>
          <div
            className=" d-flex justify-content-center align-items-center flex-column  bgHome px-2 py-2  rounded"
            // style={{ overflowX: "hidden" }}
          >
            <div
              style={{
                borderBottom: "1px solid black",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <h4 className=" py-2 px-4">{name ? name : "All Articles"}</h4>
              <div className="d-flex  gap-4" style={{ cursor: "pointer" }}>
                <div style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon
                    icon={faPlus}
                    className="text-primary cursor-pointer dropdown-toggle "
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-auto-close="outside"
                  />
                  <div
                    className=""
                    style={{
                      position: "absolute",
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                      color: "black",
                      padding: "10px 15px",
                      top: "210px",
                    }}
                  >
                    <div className="dropdown">
                      <form
                        className="dropdown-menu p-4"
                        onSubmit={handleSubmit}
                      >
                        <h4 className="text-center pt-2 text-decoration-underline">
                          Article Details
                        </h4>
                        <div className="mb-3">
                          <label htmlFor="categoryName" className="form-label">
                            Article Title
                          </label>
                          <input
                            type="text"
                            name="CategoryName"
                            value={formData.CategoryName}
                            onChange={handleInputChange}
                            className="form-control"
                            id="categoryName"
                            placeholder="Article Title"
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="image" className="form-label">
                            Article Image
                          </label>
                          <input
                            type="file"
                            name="Image"
                            accept="Image/*"
                            onChange={handleImageChange}
                            className="form-control"
                            placeholder="image"
                          />
                        </div>
                        <div className="mb-3">
                          <label
                            htmlFor="categoriesArticleId"
                            className="form-label"
                          >
                            Categories Articles ID from 1 to 12
                          </label>
                          <input
                            type="number"
                            name="CategoriesArticleId"
                            value={formData.CategoriesArticleId}
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Categories Articles ID from 1 to 12"
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="description" className="form-label">
                            Article content
                          </label>
                          <textarea
                            name="Description"
                            value={formData.Description}
                            onChange={handleInputChange}
                            className="form-control"
                            id="description"
                            placeholder="description"
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="symptoms" className="form-label">
                            Symptoms
                          </label>
                          <textarea
                            name="Symptoms"
                            value={formData.Symptoms}
                            onChange={handleInputChange}
                            className="form-control"
                            id="symptoms"
                            placeholder="symptoms"
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="treatment" className="form-label">
                            Treatment
                          </label>
                          <textarea
                            name="Treatment"
                            value={formData.Treatment}
                            onChange={handleInputChange}
                            className="form-control"
                            id="treatment"
                            placeholder="treatment"
                          />
                        </div>
                        <div className="w-100 d-flex align-items-center justify-content-center">
                        <button type="submit" className="btn btn-primary">
                          Add Article
                        </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div
                  onClick={handleDropdownnn}
                  style={{ position: "relative", cursor: "pointer" }}
                >
                  <FontAwesomeIcon
                    className="text-primary cursor-pointer"
                    icon={faAngleDown}
                  />
                  <div
                    className={`${shownn ? "  d-block z-3 " : "  d-none "}`}
                    style={{
                      position: "absolute",
                      top: "18px",
                      borderRadius: "12px",
                      overflowX: "hidden",
                      right: "4px",
                      backgroundColor: "#fff",
                      color: "black",
                      padding: "10px 15px",
                      width: "230px",
                    }}
                  >
                    <ul style={{ overflowY: "scroll", height: "350px" }}>
                      <li
                        className="mb-2 text-primary"
                        onClick={() => setSelectedCategory(null)}
                      >
                        All Articles
                      </li>
                      {categoryArticles.map((item) => (
                        <li
                          className={`mb-2 hov px-1 py-1 ${
                            selectedCategory === item
                              ? "bg-primary text-white"
                              : "text-black"
                          }`}
                          key={item.category}
                          onClick={() => {
                            handleCategoryClick(item);
                            setName(item.category);
                          }}
                        >
                          {item.category}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {selectedCategory !==null? (
              <div className="w-100 px-1 py-2 container">
                <ul className="w-100 px-3 row gap-3  justify-content-center ">
                  {displayedArticles?.map((article) => (
                    <li
                      key={article.id}
                      className="position-relative col-10 col-lg-5 bg-white d-flex px-2 py-4 rounded-4 my-2 gap-2 align-items-center"
                    >
                      <FontAwesomeIcon
                        onClick={() => handleDeleteClick(article.id)}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          top: "9px",
                          right: "13px",
                          fontSize: "23px",
                          color: "darkgrey",
                        }}
                        icon={faClose}
                      />
                      <ImageComponent
                        height={"90px"}
                        width={"50% "}
                        border={"17px"}
                        base64String={article.image}
                      />
                      <h6 style={{ overflowX: "hidden ", marginTop: "9px" }}>
                        {article.categoryName}
                      </h6>
                    </li>
                  ))}

                  <Pagination
                    itemsPerPage={articlesPerPage}
                    totalItems={
                      selectedCategory
                        ? selectedCategory?.articles?.length
                        : articlesCategory.length
                    }
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                </ul>
              </div>
            ) : (
              <ul className="w-100 px-3 row gap-3  justify-content-center ">
                {paginate(articlesCategory, currentPage, articlesPerPage).map(
                  (article) => (
                    <li
                      key={article.id}
                      className=" position-relative col-10 col-lg-5 bg-white d-flex px-1 py-3 rounded-4 my-2 gap-2 align-items-center"
                    >
                      {/* <FontAwesomeIcon
                      onClick={()=>handleDelete1(article.id)}
                        style={{
                          cursor:"pointer",
                          position: "absolute",
                          top: "12px",
                          right: "15px",
                          fontSize: "25px",
                          color: "darkgrey",
                        }}
                        icon={faClose}
                      /> */}

                      <ImageComponent
                        height={"90px"}
                        width={"50% "}
                        border={"17px"}
                        base64String={article.image}
                      />
                      <h6 style={{ overflowX: " hidden", fontSize: "16px" }}>
                        {article.categoryName}
                      </h6>
                    </li>
                  )
                )}
                <Pagination
                  itemsPerPage={articlesPerPage}
                  totalItems={articlesCategory.length}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </ul>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

const Pagination = ({
  itemsPerPage,
  totalItems,
  currentPage,
  onPageChange,
}) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className="mx-auto w-100 d-flex justify-content-center">
      <ul className="pagination mx-auto">
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={`page-item ${number === currentPage ? "active" : ""}`}
          >
            <button onClick={() => onPageChange(number)} className="page-link">
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ArticlesDashboard;
